// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1g6g7","icon":"SortAdornment_icon__2ClNP","up":"SortAdornment_up__3zBBk","down":"SortAdornment_down__2znWR","active":"SortAdornment_active__w4cC7"};